import type { CertComplianceEmployee, TrainingComplianceEmployee } from "./api";

export type ComplianceStatus = "compliant" | "expiring" | "non_compliant" | "noData" | "notApplicable";

/** Presentation of existing requirements and records; does not invent requirements. */
function status(required: unknown[], held: unknown[], missing: unknown[], expired: unknown[], expiring: unknown[]): ComplianceStatus {
  if (missing.length || expired.length) return "non_compliant";
  if (expiring.length) return "expiring";
  if (!held.length) return required.length ? "noData" : "notApplicable";
  return "compliant";
}

export function getCertStatus(employee: CertComplianceEmployee): ComplianceStatus {
  if (employee.complianceDataAvailable === false) return "noData";
  const result = status(employee.requiredCerts, employee.heldCerts, employee.missingCerts, employee.expiredCerts, employee.expiringCerts);
  return result === "notApplicable" && !employee.positionId ? "noData" : result;
}

export function getTrainStatus(employee: TrainingComplianceEmployee): ComplianceStatus {
  if (employee.complianceDataAvailable === false) return "noData";
  const incomplete = employee.heldTrainings.some(item => item.isRecurring && !item.completedDate && !item.expiryDate);
  const result = status(employee.requiredTrainings, employee.heldTrainings, employee.missingTrainings, employee.expiredTrainings, employee.expiringTrainings);
  return (incomplete && result === "compliant") || (result === "notApplicable" && !employee.positionId) ? "noData" : result;
}
